import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import SvgDropDownArrow from '@material-ui/icons/ExpandMore';

import { helper } from '../common/common';
import ViewStack from './ViewStack';

const styles = (theme) => {
    return {
        paper: {
            backgroundColor: theme.palette.primary.main,
            width: '100%',
            height: '100%',
        },
        select: {
            marginTop: 0,
            width: '100%',
            textAlign: 'left',
            fontSize: 13,
            color: theme.palette.primary.displayText,
        },
        selectDisplay: {
            paddingLeft: 16,
            paddingRight: 32,
            '&$selectDisabled': {
                color: theme.palette.primary.disabledDisplayText,
            },
            '&:focus': {
                backgroundColor: theme.palette.common.transparent,
            }
        },
        selectMenu: {
            backgroundColor: theme.palette.primary.main,
            maxHeight: '40%',
        },
        selectMenuList: {
            margin: 0,
            padding: 0,
            borderColor: theme.palette.primary.mainBorder,
            borderWidth: 1,
            borderStyle: 'solid',
            backgroundColor: theme.palette.primary.main,
        },
        selectMenuItem: {
            fontSize: 13,
            margin: 0,
            paddingTop: 2,
            paddingBottom: 2,
            paddingLeft: 16,
            color: theme.palette.primary.displayText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.hoverOverlay,
            },
            '&$selectSelected': {
                color: theme.palette.primary.selectedDisplayText,
            },
            '&$selectSelected:not(:hover)': {
                backgroundColor: theme.palette.primary.main,
            }
        },
        selectIcon: {
            ...theme.iconStyle.size[18],
            marginRight: 12,
            top: 'calc(50% - 9px)',
            right: 0,
            position: 'absolute',
            pointerEvents: 'none',
            '&$selectDisabled': {
                color: theme.palette.primary.disabledDisplayText,
            }
        },
        selectDefault: {},
        selectDisabled: {},
        selectSelected: {},
        inputError: {},
        inputFocused: {},
        inputDisabled: {},
    };
}

class DateControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateList: null,
        };
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        const nextView = nextProps.viewStack.peek();

        if (!nextView.layer) {
            return false;
        }

        const nextUid = nextView.uid;
        const [nextLayerType, nextLayerIndex] = nextView.layerSelection;

        if (this._uid !== nextUid || this._layerType !== nextLayerType) {
            this._uid = nextUid;
            this._layerType = nextLayerType;

            this._populateList();
        }

        return (this._layerIndex !== nextLayerIndex || this.state.dateList !== nextState.dateList);
    }

    render = () => {
        const view = this.props.viewStack.peek();
        const l = view.selectedLayer;

        if (!l || !this.state.dateList || this.props.viewStack.isDefaultBase()) {
            return null;
        }

        this._layerIndex = l.selectedLayerIndex;

        this._uid = view.uid;

        const disabled = (this.state.dateList.length <= 1);

        const { classes } = this.props;

        const selectClasses = {
            select: classes.selectDisplay,
            disabled: classes.selectDisabled,
        };

        const inputClasses = {
            error: classes.inputError,
            focused: classes.inputFocused,
            disabled: classes.inputDisabled,
        };

        const menuProps = {
            classes: {
                paper: classes.selectMenu,
            },
            MenuListProps: {
                className: classes.selectMenuList,
            },
            PopoverClasses: {
            },
            getContentAnchorEl: null,
            anchorReference: 'anchorEl',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
        };

        return (
            <div className={this.props.className}>
                <Paper
                    className={classes.paper}
                    square={false}
                >
                    <Select
                        className={classes.select}
                        classes={selectClasses}
                        input={<Input classes={inputClasses} disableUnderline={true} />}
                        MenuProps={menuProps}
                        IconComponent={this._renderDropDownArrow}
                        value={this._layerIndex}
                        onChange={this._handleSelection}
                        disabled={disabled}
                    >
                        {this.state.dateList}
                    </Select>
                </Paper>
            </div>
        );
    }

    _renderDropDownArrow = () => {
        const disabled = (this.state.dateList.length <= 1);

        const { classes } = this.props;

        const selectState = (disabled) ? classes.selectDisabled : classes.selectDefault;

        return (
            <SvgDropDownArrow className={classNames(classes.selectIcon, selectState)} />
        );
    }

    _populateList = () => {
        const view = this.props.viewStack.peek();
        const selectedLayer = view.selectedLayer;

        if (!selectedLayer) {
            return;
        }

        var dateList = [];
        var index = 0;

        const { classes } = this.props;

        const menuItemClasses = {
            root: classes.selectMenuItem,
            selected: classes.selectSelected,
        }

        for (const v of selectedLayer.data) {
            if (v.date && v.date > 0) {
                dateList.push(<MenuItem
                    classes={menuItemClasses}
                    value={index}
                    key={index}
                    dense={true}
                >
                    {helper.makeDate(v.date)}</MenuItem>);

                ++index;
            }
        }

        if (this.props.viewStack.isDefaultBase() || dateList.length === 0) {
            dateList = null;
        }

        if (this.state.dateList !== dateList) {
            this.setState({
                dateList: dateList,
            });
        }
    }

    _handleSelection = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    }
}

DateControl.propTypes = {
    viewStack: PropTypes.instanceOf(ViewStack).isRequired,
    onChange: PropTypes.func,
}

export default withStyles(styles)(DateControl);
